export var SECONDARY_NAV_HEIGHT = 64;
export var SECONDARY_NAV_ITEM_PADDING_HORIZONTAL = 16;
export var SECONDARY_NAV_ITEM_OUTLINE_WIDTH = 2;
export var SECONDARY_NAV_ITEM_SELECTION_INDICATOR_HEIGHT = 4;
export var SECONDARY_NAV_DROPDOWN_ITEM_HORIZONTAL_PADDING = 8;
export var SECONDARY_NAV_DROPDOWN_ITEM_VERTICAL_PADDING = 16;
export var SECONDARY_NAV_DROPDOWN_ITEM_MIN_WIDTH = 220;
export var SECONDARY_NAV_TEXT_COLOR = 'neutral90';
export var SECONDARY_NAV_BACKGROUND_COLOR = 'neutral05';
export var SECONDARY_NAV_BORDER_COLOR = 'neutral20';
export var SECONDARY_NAV_ITEM_OUTLINE_COLOR = 'neutral100';
export var SECONDARY_NAV_ITEM_BORDER_COLOR = 'neutral80';
export var SECONDARY_NAV_DROPDOWN_ITEM_TEXT_COLOR = 'primary70';
export var SECONDARY_NAV_DROPDOWN_ITEM_HOVER_COLOR = 'neutral05';